import { RouterView } from "vue-router";
import { SubcontractSettlementRouting } from "./subcontract-settlement/settlement.routing";
import { ProfileRouting } from "./profile/profile.routing";
import { FollowRouting } from "./follow/follow.routing";
import { SolutionRouting } from "./solution/solution.routing";
import { SubcontractPaymentRouting } from "./subcontract-payment/subcontract-payment.routing";

export const SubcontractManagementRouting = {
  // path: "/subcontractManagement",
  // name: "subcontractManagement",
  // redirect: "/subcontractManagement/profile/list",
  // component: RouterView,
  // meta: { title: "分包管理", icon: "fenbao" },
  children: [...ProfileRouting, ...SubcontractSettlementRouting, ...SubcontractPaymentRouting],
};
